import './SpecialDayOffRequestForm.scss';
import { useTranslation } from 'react-i18next';
import { SpecialDayOffCalendar } from './SpecialDayOffCalendar';
import Button from '@mui/material/Button';
import { useSpecialDayOffProvider } from '../../providers/SpecialDayOffProvider';
import { useState, useEffect, useCallback } from 'react';
import {
  getEasternTime,
  getNumberOfDays,
  getDateInWeekDayMonthDateFormat,
  formatDate
} from '../../helpers/dateHelpers';
import SpecialDayOffApiFailure from './SpecialDayOffApiFailure';
import Loader from '../Loader/Loader';
import { useSdoApiError } from '../../providers/SdoApiErrorProvider';
import { months } from '../../constants/dates';
import {
  sdoStatusType,
  pilotScheduleCodeTypes,
  filterAndSortTimeAsc,
  checkAndModifyRange,
  isDateSame,
  sortTimeAsc
} from './SpecialDayOffHelper';
import { useNotifications } from '../../providers/Notifications';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';
import { PilotSchedule } from '../../models/SdoInterface';
import {
  addDays,
  differenceInDays,
  isAfter,
  isBefore,
  subDays
} from 'date-fns';
import AcErrorDialog from '../AcErrorDialog/AcErrorDialog';
import { error } from '../../constants/bindings';

export default function SpecialDayOffRequestForm({
  setToggleSdoFormVisible,
  editSdoForm,
  requestedSdoDates,
  setRequestedSdoDates,
  sdoConflictRequest,
  currentPairingMonthData
}) {
  const specialDayOffContext = useSpecialDayOffProvider();
  const NotificationsContext = useNotifications();
  const [sdoBlockDates, setSdoBlockDates] = useState({});
  const [requestedDates, setRequestedDates] = useState<any>([]);
  const currentYear = getEasternTime().getFullYear();
  const { t } = useTranslation();
  const searchYear = {
    year: currentYear
  };

  const [requestBtnDisabled, setRequestBtnDisabled] = useState(true);
  const [selectedDays, setSelectedDays] = useState([]);
  const sdoApiErrorContext = useSdoApiError();
  const [sdoMonthYear, setSdoMonthYear] = useState('');
  const [requestedMonth, setRequestedMonth] = useState('');
  const [isSdoMonthDateSelected, setIsSdoMonthDateSelected] = useState(true);
  const [isBlockedDateSelected, setIsBlockedDateSelected] = useState(false);
  const [additionalQual, setAdditionalQual] = useState('');
  const [formSubmissionLoading, setFormSubmissionLoading] = useState(false);
  const [blockedDates, setBlockedDates] = useState<any>([]);
  const [blockEndDate, setBlockEndDate] = useState('');
const [showNetworkError, setShowNetworkError] = useState(false);
  useEffect(() => {
    if (
      !requestedSdoDates &&
      !requestedSdoDates.fromDate &&
      !requestedSdoDates.toDate
    ) {
      return;
    }
    let datesArr: any = findRequestedSdoDates().length
      ? findRequestedSdoDates()
      : requestedSdoDates.fromDate
        ? new Array(new Date(requestedSdoDates?.fromDate + ' 00:00'))
        : [];
    setRequestedDates(datesArr);
    getSdoMonthYear();
    setRequestedMonth(
      months[Number(specialDayOffContext.sdoInfoTabData?.sdoMonth) - 1]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterPilotSchedule = (pilotSchedule) => {
    const calendarStart = new Date(
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarStart +
        ' 00:00'
    );
    const calendarEnd = new Date(
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarEnd +
        ' 00:00'
    );
    const pilotScheduleEnd = new Date(pilotSchedule?.end_date + ' 00:00');
    const pilotScheduleStart = new Date(pilotSchedule?.start_date + ' 00:00');

    if (
      // Modified by Parthkumar Prajapati
      // From
      // pilotScheduleEnd.getTime() >= calendarStart.getTime() &&
      // pilotScheduleEnd.getTime() <= calendarEnd.getTime()
      // To
      pilotScheduleEnd.getTime() >= calendarStart.getTime() &&
      pilotScheduleStart.getTime() <= calendarEnd.getTime()
    ) {
      return true;
    }

    return false;
  };

  const blockGapDates = (
    sdoBlockDates: PilotSchedule[],
    calendarStartDay: Date,
    calendarEndDay: Date,
    gap: number
  ) => {
    let gapDatesArr = [] as PilotSchedule[];
    sdoBlockDates.forEach((sdo) => {
      const leftGapStart = subDays(new Date(sdo.start_date + ' 00:00'), 1);
      const rightGapStart = addDays(new Date(sdo.end_date + ' 00:00'), 1);
      for (
        let day = leftGapStart;
        !isBefore(day, calendarStartDay) &&
        differenceInDays(leftGapStart, day) < gap;
        day = subDays(day, 1)
      ) {
        gapDatesArr.push({
          code: 'GAP',
          start_date: formatDate(day),
          end_date: formatDate(day)
        });
      }
      for (
        let day = rightGapStart;
        !isAfter(day, calendarEndDay) &&
        differenceInDays(day, rightGapStart) < gap;
        day = addDays(day, 1)
      ) {
        gapDatesArr.push({
          code: 'GAP',
          start_date: formatDate(day),
          end_date: formatDate(day)
        });
      }
    });

    return clubTheDates(gapDatesArr, calendarStartDay, calendarEndDay);
  };

  useEffect(() => {
    if (
      !specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarStart &&
      !specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarEnd &&
      !specialDayOffContext.sdoCalendarData?.calendarDays[0]?.blockEnd
    ) {
      return;
    }
    setSdoBlockDates({
      start: new Date(
        specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarStart +
          ' 00:00'
      ),
      end: new Date(
        specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarEnd +
          ' 00:00'
      ),
      numbersOfDays: specialDayOffContext.sdoCalendarData?.calendarDays[0]?.days
    });
    setBlockEndDate(
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.blockEnd
    );
    setAdditionalQual(
      specialDayOffContext.sdoCalendarData?.additionalQualification
    );

    if (!specialDayOffContext.sdoCalendarData?.pilotSchedule) return;
    specialDayOffContext.sdoCalendarData?.pilotSchedule?.sort(
      (a, b) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
    );
    const calendarStartDay = new Date(
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarStart +
        ' 00:00'
    );
    const calendarEndDay = new Date(
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarEnd +
        ' 00:00'
    );

    /* filter the blockedDates Array to filter the item whose end date is not within calendar start date and calendar end date */
    const pilotSchedules =
      specialDayOffContext.sdoCalendarData?.pilotSchedule.filter(
        (pilotSchedule) => filterPilotSchedule(pilotSchedule)
      );
    const otherSchedules = pilotSchedules
      .filter((schedule) => schedule.code === 'Other')
      .sort(
        (a, b) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
      );
    const embargoSchedules = pilotSchedules
      .filter((schedule) => schedule.code === 'Embargo')
      .sort(
        (a, b) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
      );
    const trainingSchedules = pilotSchedules
      .filter(
        (schedule) =>
          schedule.code === 'SIM' ||
          schedule.code === 'ART' ||
          schedule.code === 'SCHOOL' ||
          schedule.code === 'IOE'
      )
      .sort(
        (a, b) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
      );
    const vacationSchedules = pilotSchedules
      .filter((schedule) => schedule.code === 'Vacation')
      .sort(
        (a, b) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
      );
    const pairingSchedules = checkAndModifyRange(
      filterAndSortTimeAsc(
        specialDayOffContext.sdoCalendarData?.pilotSchedule,
        [pilotScheduleCodeTypes.PAIRING]
      ),
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarStart,
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarEnd
    );

    let sdoSchedules = [];
    const sdoMonth = specialDayOffContext.sdoInfoTabData?.sdoMonth;
    const sdoYear = specialDayOffContext.sdoInfoTabData?.sdoYear;

    //calculating previous month and to check for previously approved requests
    const previousMonth =
      Number(specialDayOffContext.sdoInfoTabData?.sdoMonth) - 1;
    const previousYear = Number(specialDayOffContext.sdoInfoTabData?.sdoYear);

    const bufferGap =
      specialDayOffContext.sdoCalendarData?.gap !== undefined
        ? specialDayOffContext.sdoCalendarData.gap
        : 5;

    //checking previous month's approved request are overlapping or not with the current month
    const previousMonthSDOs = specialDayOffContext.sdoMyRequestData.filter(
      (sdo) =>
        sdo.sdoYear === sdoYear &&
        parseInt(sdo.sdoMonth) === previousMonth &&
        parseInt(sdo.sdoYear) === previousYear &&
        sdo.status === sdoStatusType.APPROVED &&
        /* adding condition to check whether the previous SDO'S END date is with in the gap and previous date end dateis on the same day or later */ differenceInDays(
          new Date(
            specialDayOffContext.sdoCalendarData?.calendarDays[0]
              ?.calendarStart + ' 00:00'
          ),
          new Date(sdo.requestedToDt + ' 00:00')
        ) <= bufferGap &&
        differenceInDays(
          new Date(
            specialDayOffContext.sdoCalendarData?.calendarDays[0]
              ?.calendarStart + ' 00:00'
          ),
          new Date(sdo.requestedToDt + ' 00:00')
        ) > 0
    );
    sdoSchedules = checkAndModifyRange(
      specialDayOffContext.sdoMyRequestData
        .filter(
          (sdo) =>
            sdo.sdoYear === sdoYear &&
            (sdo.sdoMonth === sdoMonth ||
              // Check for previously approved request overlap with current month
              ((parseInt(sdo.sdoMonth) === parseInt(sdoMonth) - 1 ||
                (sdoYear - 1 === parseInt(sdo.sdoYear) &&
                  parseInt(sdo.sdoMonth) === 12 &&
                  parseInt(sdoMonth) === 1)) &&
                sdo.status === sdoStatusType.APPROVED &&
                new Date(sdo.requestedToDt).getTime() >=
                  calendarStartDay.getTime())) &&
            (!Object.keys(requestedSdoDates).length ||
              sdo.transactionId !== requestedSdoDates.transactionId)
        )
        .map((sdo) => ({
          start_date: sdo.requestedFromDt,
          end_date: sdo.requestedToDt,
          code:
            sdo.sdoMonth === sdoMonth
              ? pilotScheduleCodeTypes.SDO_REQ
              : pilotScheduleCodeTypes.SDO
        }))
        .sort(sortTimeAsc),
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarStart,
      specialDayOffContext.sdoCalendarData?.calendarDays[0]?.calendarEnd
    );

    let calendarOtherBlockDays = clubTheDates(
      otherSchedules,
      calendarStartDay,
      calendarEndDay
    );
    let calendarEmbargoBlockDays = clubTheDates(
      embargoSchedules,
      calendarStartDay,
      calendarEndDay
    );
    let calendarTrainingBlockDays = clubTheDates(
      trainingSchedules,
      calendarStartDay,
      calendarEndDay
    );
    let calendarVacationBlockDays = clubTheDates(
      vacationSchedules,
      calendarStartDay,
      calendarEndDay
    );
    let calendarPairingsBlockDays = clubTheDates(
      pairingSchedules,
      calendarStartDay,
      calendarEndDay
    );
    let calendarSDOBlockDays = clubTheDates(
      sdoSchedules,
      calendarStartDay,
      calendarEndDay
    );

    // converting the previous month'snapproved data to pilot schedule formate

    const previousMonthSDOBlockDays = previousMonthSDOs.map((sdo) => {
      return {
        start_date: sdo.requestedFromDt,
        end_date: sdo.requestedToDt,
        code: pilotScheduleCodeTypes.SDO
      };
    });

    //calculating the gap days explicitly for the previous month's approved SDOs

    let previousMonthSDOBlockDaysGap = blockGapDates(
      previousMonthSDOBlockDays,
      calendarStartDay,
      calendarEndDay,
      bufferGap
    );

    let calendarGapDays = [
      ...blockGapDates(
        calendarSDOBlockDays,
        calendarStartDay,
        calendarEndDay,
        specialDayOffContext.sdoCalendarData?.gap !== undefined
          ? specialDayOffContext.sdoCalendarData.gap
          : 5
      ),
      ...previousMonthSDOBlockDaysGap
    ];
    const calendarBlockDays = [
      ...calendarEmbargoBlockDays,
      ...calendarPairingsBlockDays,
      ...calendarTrainingBlockDays,
      ...calendarVacationBlockDays,
      ...calendarSDOBlockDays,
      ...calendarGapDays,
      ...calendarOtherBlockDays
    ].sort(
      (a, b) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
    );
    setBlockedDates(calendarBlockDays);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialDayOffContext.sdoCalendarData]);

  useEffect(() => {
    if (!selectedDays.length) {
      setRequestBtnDisabled(true);
      return;
    }
    setIsSdoMonthDateSelected(checkIfSdoMonthDateNotSelected());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDays]);

  useEffect(() => {
    // Simple logic: enable button if dates are selected and no blocking conditions
    const hasSelectedDates = selectedDays.length > 0;
    const isLocalLoading = formSubmissionLoading; // Only check local loading state

    if (isLocalLoading) {
      setRequestBtnDisabled(true);
    } else if (
      hasSelectedDates &&
      isSdoMonthDateSelected &&
      !isBlockedDateSelected
    ) {
      setRequestBtnDisabled(false);
    } else {
      setRequestBtnDisabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedDays.length,
    isSdoMonthDateSelected,
    isBlockedDateSelected,
    formSubmissionLoading
  ]);

  useEffect(() => {
    // Reset selected dates when API error occurs, but allow re-selection
    if (sdoApiErrorContext.sdoError) {
      setSelectedDays([]);
      setRequestBtnDisabled(true);
      setFormSubmissionLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdoApiErrorContext.sdoError]);

  const checkIfSdoMonthDateNotSelected = () => {
    let sdoMonthFlag = false;
    const selectedDates =
      selectedDays.length > 1
        ? getNumberOfDays(
            selectedDays[0],
            selectedDays[selectedDays.length - 1]
          )
        : getNumberOfDays(selectedDays[0], selectedDays[0]);

    selectedDates &&
      selectedDates.forEach((date) => {
        if (new Date(date).getTime() <= new Date(blockEndDate).getTime()) {
          sdoMonthFlag = true;
        }
      });

    return sdoMonthFlag;
  };

  const getSdoMonthYear = () => {
    if (
      !specialDayOffContext.sdoInfoTabData?.sdoMonth &&
      !specialDayOffContext.sdoInfoTabData?.sdoYear
    ) {
      return 'N/A';
    }
    const sdoMonth =
      months[Number(specialDayOffContext.sdoInfoTabData?.sdoMonth) - 1];
    const sdoYear = specialDayOffContext.sdoInfoTabData?.sdoYear;

    setSdoMonthYear(sdoMonth + ' ' + sdoYear);
  };

  const handleCancelFormSubmission = () => {
    setRequestedSdoDates({});
    setToggleSdoFormVisible(false);
  };

  const handleRequestFormSubmission = async () => {
    // Prevent multiple concurrent submissions
    if (formSubmissionLoading) {
      return;
    }

    setShowNetworkError(false);

    if (!navigator.onLine) {
      setShowNetworkError(true);
      return;
    }

    setFormSubmissionLoading(true);

    try {
      const selectedCalDates: any = document.querySelectorAll(
        '.sdo__calendar__day--selected'
      );

      let sdoReqFormData: any = {};
      if (selectedCalDates && selectedCalDates.length > 1) {
        sdoReqFormData = {
          sdoYear: String(specialDayOffContext.sdoInfoTabData.sdoYear),
          sdoMonth: String(specialDayOffContext.sdoInfoTabData.sdoMonth),
          sdoFromDt: selectedCalDates[0].dataset.value,
          sdoToDt: selectedCalDates[selectedCalDates.length - 1].dataset.value,
          duration: selectedCalDates.length,
          remarks: 'Waiting for Approval',
          status: sdoStatusType.SUBMITTED,
          sdoConflictReview: sdoConflictRequest ? 'Y' : 'N',
          additionalQualifications: additionalQual
        };
      } else {
        sdoReqFormData = {
          sdoYear: String(specialDayOffContext.sdoInfoTabData.sdoYear),
          sdoMonth: String(specialDayOffContext.sdoInfoTabData.sdoMonth),
          sdoFromDt: selectedCalDates[0].dataset.value,
          sdoToDt: selectedCalDates[0].dataset.value,
          duration: selectedCalDates.length,
          remarks: 'Waiting for Approval',
          status: sdoStatusType.SUBMITTED,
          sdoConflictReview: sdoConflictRequest ? 'Y' : 'N',
          additionalQualifications: additionalQual
        };
      }

      if (!sdoReqFormData) return;

      if (editSdoForm) {
        sdoReqFormData.transactionId = requestedSdoDates.transactionId;
      }

      await specialDayOffContext.saveSdoMyRequestFormData(sdoReqFormData);
      updateConflictNotificationViewedOnEdit(sdoReqFormData);

      //Added twice in this method handle network error before and after invocation of API
      if (!navigator.onLine) {
      setShowNetworkError(true);
      return;
      }

      // Handle success: close form and refresh data
      if (!sdoApiErrorContext.sdoError) {
        specialDayOffContext.getSdoMyRequestData(searchYear);
        setToggleSdoFormVisible(false);
      }
    } catch (error) {
      console.error('Error during SDO submission:', error);
    } finally {
      setFormSubmissionLoading(false);
    }
  };

  function clubTheDates(
    scheduleDates: PilotSchedule[],
    calendarStartDay: Date,
    calendarEndDay: Date
  ) {
    const oneDay = 60 * 60 * 24 * 1000;
    let blockoutDatesArr = [] as PilotSchedule[];
    scheduleDates.forEach((item, index) => {
      if (
        // Modified by Parthkumar Prajapati
        // From
        // new Date(item.start_date + ' 00:00').getTime() >= calendarStartDay.getTime() ||
        // new Date(item.end_date + ' 00:00').getTime() <= calendarEndDay.getTime()
        // To
        new Date(item.start_date + ' 00:00').getTime() <=
          calendarEndDay.getTime() &&
        new Date(item.end_date + ' 00:00').getTime() >=
          calendarStartDay.getTime()
      ) {
        if (!blockoutDatesArr.length) blockoutDatesArr.push({ ...item });
        else {
          if (
            scheduleDates[index - 1] &&
            item.code === scheduleDates[index - 1].code
          ) {
            if (
              new Date(item.start_date + ' 00:00').getTime() -
                new Date(
                  scheduleDates[index - 1].end_date + ' 00:00'
                ).getTime() ===
                oneDay ||
              new Date(item.start_date + ' 00:00').getTime() ===
                new Date(scheduleDates[index - 1].end_date + ' 00:00').getTime()
            ) {
              if (blockoutDatesArr[blockoutDatesArr.length - 1])
                blockoutDatesArr[blockoutDatesArr.length - 1].end_date =
                  item.end_date;
            } else blockoutDatesArr.push({ ...item });
          } else blockoutDatesArr.push({ ...item });
        }
      }
    });
    return blockoutDatesArr;
  }

  // Removed the useEffect dependent on specialDayOffContext.saveSdoLoading
  // as it was causing stuck loading state issues. Navigation is now handled
  // directly in handleRequestFormSubmission

  const updateConflictNotificationViewedOnEdit = (sdoReqFormData) => {
    const requestedDatesOnEdit = requestedDates;
    const selectedDatesOnUpdate: any[] = getNumberOfDays(
      sdoReqFormData?.sdoFromDt,
      sdoReqFormData?.sdoToDt
    );
    var isSame =
      requestedDatesOnEdit.length === selectedDatesOnUpdate.length &&
      requestedDatesOnEdit.every(
        (o, i) =>
          Object.keys(o).length ===
            Object.keys(selectedDatesOnUpdate[i]).length &&
          Object.keys(o).every((k) => o[k] === selectedDatesOnUpdate[i][k])
      );
    if (!isSame) {
      if (!NotificationsContext?.notifications?.result) return;
      if (NotificationsContext?.notifications?.result?.length >= 1) {
        NotificationsContext.notifications.result.forEach((msg) => {
          if (msg.module === 'sdo.conflict') {
            NotificationsContext.updateNotificationViewed(
              msg.year,
              msg.month,
              'sdo.conflict',
              msg.notificationId
            );
          }
        });
      }
    }
  };

  const findRequestedSdoDates = () => {
    const start = new Date(requestedSdoDates?.fromDate + ' 00:00');
    const end = new Date(requestedSdoDates.toDate + ' 00:00');
    let sdoDatesArray: any[] = getNumberOfDays(start, end);
    return sdoDatesArray;
  };

  const getNumberOfSelectedDays = (selectedDays) => {
    return selectedDays && selectedDays.length
      ? selectedDays.length
      : requestedDates && requestedDates.length
        ? requestedDates.length
        : 0;
  };

  const getSelectedDaysText = useCallback(
    () => {
      if (!selectedDays && !requestedDates) return '';
      let activeSDOStartDate;
      let activeSDOSelectedDatesText = '';

      if (selectedDays.length) {
        activeSDOStartDate = new Date(selectedDays[0]);
        activeSDOSelectedDatesText = getFromToSelectedDays(selectedDays);
      } else if (requestedDates.length) {
        activeSDOStartDate = new Date(requestedDates[0]);
        activeSDOSelectedDatesText = getFromToSelectedDays(
          requestedDates.map((date) => new Date(date))
        );
      }

      const blockedSDO = blockedDates.filter(
        (blockDate) => blockDate.code === pilotScheduleCodeTypes.SDO_REQ
      );
      let blockedSDOStartDate = null as Date | null;
      let blockedSDODatesText = '';
      if (blockedSDO.length) {
        blockedSDOStartDate = new Date(blockedSDO[0].start_date);
        blockedSDODatesText = getFromToSelectedDays(
          getNumberOfDays(
            new Date(blockedSDO[0].start_date),
            new Date(blockedSDO[0].end_date)
          ).map((date) => new Date(date))
        );
      }

      return blockedSDOStartDate && activeSDOStartDate
        ? isBefore(activeSDOStartDate, blockedSDOStartDate)
          ? `${activeSDOSelectedDatesText}, ${blockedSDODatesText}}`
          : `${blockedSDODatesText}, ${activeSDOSelectedDatesText}`
        : blockedSDOStartDate
          ? blockedSDODatesText
          : activeSDOStartDate
            ? activeSDOSelectedDatesText
            : '';
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedDays, requestedDates]
  );

  const getFromToSelectedDays = (selectedDays) => {
    if (selectedDays.length >= 2) {
      return (
        getDateInWeekDayMonthDateFormat(selectedDays[0]) +
        ' - ' +
        getDateInWeekDayMonthDateFormat(selectedDays[selectedDays.length - 1]) +
        ' (' +
        getNumberOfSelectedDays(selectedDays) +
        ' days)'
      );
    } else if (selectedDays.length === 1) {
      return getDateInWeekDayMonthDateFormat(selectedDays[0]) + ' (1 day)';
    } else {
      return '';
    }
  };

  return specialDayOffContext.sdoMyRequestLoading || formSubmissionLoading ? (
    <Loader />
  ) : (
    <div className="sdo-request-form__container">
      <div className="sdo-request-form__info">
        <i className="icon-info-warning sdo-request-form__info--icon" />
        <span className="sdo-request-form__info--text">
          {t('specialDayOff.specialDayOffRequestForm.infoText')}
          <span style={{ fontWeight: 'bold' }}>
            {t('specialDayOff.specialDayOffRequestForm.infoText1')}
          </span>
          {t('specialDayOff.specialDayOffRequestForm.infoText2', {
            sdoYear: specialDayOffContext.sdoInfoTabData?.sdoYear
          })}
        </span>
      </div>
      {isBlockedDateSelected ? (
        <div className="sdo-request-form__blocked-date-selected-notification">
          <i className="icon-info-warning sdo-block-date-selection-warning-icon" />
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(`${t('specialDayOff.specialDayOffRequestForm.blockDateSelectedError1')}${
                blockedDates.some(
                  (blockdate) =>
                    blockdate.code === pilotScheduleCodeTypes.SDO_REQ
                )
                  ? specialDayOffContext.sdoCalendarData.gap
                    ? t(
                        'specialDayOff.specialDayOffRequestForm.blockDateSelectedError2',
                        {
                          gap: specialDayOffContext.sdoCalendarData.gap
                        }
                      )
                    : specialDayOffContext.sdoCalendarData.gap === undefined
                      ? t(
                          'specialDayOff.specialDayOffRequestForm.blockDateSelectedErrorDefaultGap'
                        )
                      : ''
                  : ''
              }`)
            }}
          />
        </div>
      ) : (
        ''
      )}
      {isSdoMonthDateSelected ? (
        ''
      ) : (
        <div className="sdo-request-form__conflict-request-notification">
          <i className="icon-Error-warning" />
          <p>
            {t('specialDayOff.specialDayOffRequestForm.errorInfoText', {
              month: requestedMonth
            })}
          </p>
        </div>
      )}

      {sdoApiErrorContext.sdoError ? <SpecialDayOffApiFailure /> : ''}

      <div className="sdo-request-form__calendar-container">
        <div className="sdo-request-form__calendar-component">
          <SpecialDayOffCalendar
            sdoMonthYear={sdoMonthYear}
            sdoBlockDates={sdoBlockDates}
            requestedDates={requestedDates}
            setRequestBtnDisabled={setRequestBtnDisabled}
            setSelectedDays={setSelectedDays}
            setIsSdoMonthDateSelected={setIsSdoMonthDateSelected}
            setIsBlockedDateSelected={setIsBlockedDateSelected}
            blockedDates={blockedDates}
          />
        </div>
        <div className="sdo-request-form__calendar-info">
          <div className="sdo-request-form__calendar-info__legends">
            <p className="sdo-request-form__calendar-info__legends-label">
              {t('specialDayOff.specialDayOffRequestForm.legend')}
            </p>
            <div className="sdo-request-form__calendar-info__legends-details">
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--embargo"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.embargo')}
                </span>
              </div>
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--pairings"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.pairings')}
                </span>
              </div>
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--training"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.training')}
                </span>
              </div>
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--vacation"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.vacation')}
                </span>
              </div>
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--SDO_REQ"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.sdoRequested')}
                </span>
              </div>
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--SDO"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.sdo')}
                </span>
              </div>
              <div className="sdo-request-form__calendar-info__legends-details--type">
                <span className="sdo-request-form__calendar-info__legends-details--other"></span>
                <span className="sdo-request-form__calendar-info__legends-details--text">
                  {t('specialDayOff.specialDayOffRequestForm.other')}
                </span>
              </div>
              {/*<div className='sdo-request-form__calendar-info__legends-details--type'>
                                    <span className='sdo-request-form__calendar-info__legends-details--selected'></span>
                                    <span className='sdo-request-form__calendar-info__legends-details--text'>{t('specialDayOff.specialDayOffRequestForm.selected')}</span>
        </div>                  */}
            </div>
          </div>
          {blockedDates && blockedDates.length ? (
            <div className="sdo-request-form__calendar-info__blocked-days">
              <p className="sdo-request-form__calendar-info__blocked-days__label">
                {t('specialDayOff.specialDayOffRequestForm.blockedDays')}{' '}
                {sdoMonthYear}
              </p>
              {blockedDates.map(
                (blockdate, index) =>
                  blockdate.code !== pilotScheduleCodeTypes.GAP &&
                  blockdate.code !== pilotScheduleCodeTypes.SDO_REQ && (
                    <div
                      className="sdo-request-form__calendar-info__blocked-days__details"
                      key={index}
                    >
                      <span className="sdo-request-form__calendar-info__blocked-days__details--type">
                        {blockdate.code === pilotScheduleCodeTypes.SDO
                          ? t(
                              'specialDayOff.specialDayOffRequestForm.sdoLegendDates'
                            )
                          : blockdate.code}
                      </span>
                      <span className="sdo-request-form__calendar-info__blocked-days__details--durations">
                        {getDateInWeekDayMonthDateFormat(
                          new Date(blockdate?.start_date)
                        )}
                        {!isDateSame(
                          blockdate?.start_date,
                          blockdate?.end_date
                        ) &&
                          `- ${getDateInWeekDayMonthDateFormat(new Date(blockdate?.end_date))}`}
                      </span>
                    </div>
                  )
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="sdo-request-form__submission">
        <p className="sdo-request-form__submission--info">
          <span className="sdo-request-form__submission--info-label">
            {t('specialDayOff.specialDayOffRequestForm.totalDaysSelected')}
          </span>
          <span className="sdo-request-form__submission--info-dates">
            {getSelectedDaysText()}
          </span>
        </p>
        <div className="sdo-request-form__submission-buttons">
          <Button
            className="sdo-request-form__submission-buttons--grey"
            onClick={() => handleCancelFormSubmission()}
          >
            {t('specialDayOff.specialDayOffRequestForm.cancel')}
          </Button>
          <Button
            className={
              requestBtnDisabled
                ? 'sdo-request-form__submission-buttons--disabled'
                : 'sdo-request-form__submission-buttons--black'
            }
            onClick={() => handleRequestFormSubmission()}
            disabled={requestBtnDisabled}
          >
            {editSdoForm
              ? t('specialDayOff.specialDayOffRequestForm.confirmUpdate')
              : t('specialDayOff.specialDayOffRequestForm.requestSdo')}
          </Button>
        </div>
      </div>
            {showNetworkError && (
        <AcErrorDialog errorCode={error.NETWORK} />
      )}
    </div>
  );
}
